import { instances } from '../store'
import EventEmitter from 'events'
import { gsap, ScrollToPlugin } from 'gsap/all'
import isMobile from 'ismobilejs'
gsap.registerPlugin(ScrollToPlugin)

export default class SmoothScroll extends EventEmitter {
  constructor() {
    super()

    window.addEventListener('DOMContentLoaded', () => {
      this.links = document.querySelectorAll('a[href^="#"]')
      for (let i = 0; i < this.links.length; i++) {
        this.links[i].addEventListener('click', e => {
          e.preventDefault()
          let hash = e.currentTarget.getAttribute('href')
          let target = document.getElementById(hash.slice(1))
          this.smoothLink(hash)
        })
      }
    })
  }
  smoothLink(hash) {
    let offset = isMobile(window.navigator).any ? 72 : 0
    gsap.to(window, {
      duration: 0.5,
      ease: 'expo.inOut',
      scrollTo: {
        y: hash,
        offsetY: offset,
      },
      onComplete: () => {
        // console.log('smoothLink Complete')
      },
    })
  }
}
